/**
 * SliderContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled container for the slider element.
 */
const SliderContainer = styled.div`
  position: fixed;
  overflow: hidden;
  width: max-content;
`;

export default withOpacity(SliderContainer);
